export default (key) => {
    const href = window.location.href;
    let url = ''
    if(href.includes('??')){
      url = window.location.href.split('??')[1]
    }else{
      url = window.location.href.split('?')[1]
    }
    if (!url) return false
    const paramsList = url.split('&')
    const params = {}
    for (let i = 0; i < paramsList.length; i++) {
      const p = paramsList[i].split('=')
      params[p[0]] = p[1]
    }
    return params[key] || null
  }
  